import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconElectrocardiogram: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconElectrocardiogram"><Path d="M9 1.15234L5.307 11.0003H1V13.0003H6.693L9 6.84835L15 22.8483L18.693 13.0003H23V11.0003H17.307L15 17.1523L9 1.15234Z" fill="currentColor"/></CentralIconBase>;
});

export default IconElectrocardiogram;
